export default __webpack_public_path__ + "static/media/wave-mobile-gradient.8ba79825.png";